import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    getDebugSettings: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'debug/debug-settings',
                    method: 'GET',
                    types: [
                        types.GET_DEBUG_SETTINGS_REQUEST,
                        types.GET_DEBUG_SETTINGS_SUCCESS,
                        types.GET_DEBUG_SETTINGS_FAILURE
                    ]
                }
            });
        }
    }
}